import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";

import { auth } from "../utils/auth";

import Login from "./Login";
import Comprobantes from "./Nominas/Print/Comprobantes";
import Despachados from "./Programaciones/Print/Despachados";
import Reportes from "./Reportes";
import DetalleTicket from "./Programaciones/Print/DetalleTicket";
import Solicitudes from "./Solicitudes/Print";
import Solicitud from "./Solicitudes/Print/Solicitud";
import Reclamaciones from "./Reclamaciones/Print";
import Reclamacion from "./Reclamaciones/Print/Reclamacion";
import Servicios from "./Servicios/Print";
import Vehiculos from "./Vehiculos/Print";
import DetalleVehiculos from "./Vehiculos/Print/ListadoDetalleVehiculos";
import Items from "./Items/Print";
import Productos from "./Productos/Print";
import RealizarInventario from "./Productos/Print/RealizarInventario";
import PrintReporteSuplidor from "./Productos/Print/ReporteSuplidor";
import HistorialVentas from "./Productos/Print/HistorialVentas";
import CatalogueOfProducts from "./Productos/Print/CatalogueOfProducts";
import HistorialComprasItems from "./Items/Print/HistorialCompras";
import HistorialComprasProductos from "./Productos/Print/HistorialCompras";
import Empleados from "./Empleados/Print";
import ListaEmpleados from "./Empleados/Print/ListaEmpleados";
import CalculoPrestaciones from "./Empleados/Print/CalculoPrestaciones";
import DetalleEmpleados from "./Empleados/Print/ListadoDetalleEmpleados";
import GastosVehiculos from "./Gastos/Print";
import Rutas from "./Rutas/Print";
import Tarjetas from "./Programaciones/Print/Tarjetas";
import Resumen from "./Nominas/Print/Resumen";
import ComprobantesEstandard from "./Nominas/Print/ComprobantesEstandard";
import ComprobantesNormales from "./Nominas/Print/ComprobantesNormales";
import DesgloseEfectivo from "./Nominas/Print/DesgloseEfectivo";
import GastosGenerales from "./GastosGenerales/Print";
import Ausentes from "./Programaciones/Print/Ausentes";
import NoDespachados from "./Programaciones/Print/NoDespachados";
import DescuentosProgramados from "./DescuentosProgramados/Print";
import DescuentoProgramado from "./DescuentosProgramados/Print/Descuento";
import ReciboDescuentoProgramado from "./DescuentosProgramados/Print/Recibo";
import Incentivos from "./Incentivos/Print/";
import Incentivo from "./Incentivos/Print/Incentivo";
import Cuentas from "./Cuentas/Print/";
import GIPrestamos from "./GI/Prestamos/Print/Semana";
import GIGrupos from "./GI/Grupos/Print/";
import Sobres from "./Nominas/Print/Sobres";
import SobresDetalles from "./Nominas/Print/SobresDetalles";
import Transacciones from "./Cuentas/Print/Transacciones";
import ComprobantesDetalles from "./Nominas/Print/ComprobantesDetalles";
import PrintFacturas from "./Ingresos/Facturacion/Components/PrintFacturas";
import PrintFacturasResumen from "./Ingresos/Facturacion/Components/PrintFacturasResumen";
import PrintSingleFactura from "./Ingresos/Facturacion/Components/PrintSingleFactura";
import PrintSingleFacturaNew from "./Ingresos/Facturacion/Components/PrintSingleFacturaNew";
import PrintOrdenes from "./Ingresos/Pedidos/Components/PrintOrdenes";
import PrintSingleOrden from "./Ingresos/Pedidos/Components/PrintSingleOrden";
import ReporteCuadreCajaOrden from "./Ingresos/Pedidos/Components/ReporteCuadreCaja";
import ReporteCuadreCajaOrdenVenta from "./Ingresos/Pedidos/Components/ReporteCuadreCajaVenta";
import PrintSingleCotizacion from "./Ingresos/Cotizacion/Components/PrintSingleCotizacion";
import PrintCotizaciones from "./Ingresos/Cotizacion/Components/PrintCotizaciones";
import PrintComprobanteGasto from "./GastosInternos/Print/Recibo";
import ResumenColumnas from "./Nominas/Print/ResumenColumnas";
import GastosInternos from "./GastosInternos/Print/";
import ResumenColumnasCategorizado from "./Nominas/Print/ResumenColumnasCategorizado";
import Cumpleanios from "./Empleados/Print/Cumpleanios";
import PrintTransaccionesHistory from "./Contactos/Transacciones/Print/History";
import PrintTransaccionesCompras from "./Contactos/Transacciones/Print/Compras";
import SalarioNavidad from "./Empleados/Print/SalarioNavidad";
import SobreSalarioNavidad from "./Empleados/Print/SobreSalarioNavidad";
import SalarioNavidadDesglose from "./Empleados/Print/SalarioNavidadDesglose";
import SingleTransaccion from "./Cuentas/Print/SingleTransaccion";
import PrintSingleRecibo from "./Consultas/RecibosIngresos/PrintSingleRecibo";
import PrintCuentasPorCobrar from "./Consultas/CuentasPorCobrar/PrintCuentasPorCobrar";
import PrintEstadosCuenta from "./Consultas/CuentasPorCobrar/PrintEstadosCuenta";
import ComprobanteSalarioNavidad from "./Empleados/Print/ComprobanteSalarioNavidad";
import PrintRecibosIngresos from "./Consultas/RecibosIngresos/PrintRecibosIngresos";
import PrintFacturasRecurrentes from "./Ingresos/FacturacionRecurrente/Components/PrintFacturasRecurrentes";
import PrintProductosReorden from "./Productos/Print/PrintProductosReorden";
import PrintItemsReorden from "./Items/Print/PrintItemsReorden";
import ReporteCuadre from "./Ingresos/print/ReporteCuadre";
import ReporteCuadreResumido from "./Ingresos/print/ReporteCuadreResumido";
import ReporteCuadreCajaVentas from "./Ingresos/print/ReporteCuadreCajaVentas";
import PrintEvaluaciones from "./Academico/Evaluaciones/Print";
import PrintEstudiantes from "./Academico/Estudiantes/Print";
import PrintInscripciones from "./Academico/Inscripciones/Print";
import PrintInscripcionesCocurriculares from "./Academico/Cocurriculares/Inscripcion/PrintInscripciones";
import PrintCuentasPorPagar from "./Consultas/CuentasPorPagar/PrintCuentasPorPagar";
import PrintEstadosCuentaCXP from "./Consultas/CuentasPorPagar/PrintEstadosCuentaCXP";
import PrintCompras from "./Compras/PrintCompras";
import PrintSingleCompra from "./Compras/PrintSingleCompra";
import ReporteCuadreCompra from "./Compras/Print/ReporteCuadreCompra";
import ReporteDetalleCompra from "./Compras/Print/ReporteComprasDetalles";
import PrintClave from "./Academico/Estudiantes/Print/Clave";
import PrintFicha from "./Academico/Estudiantes/Print/Ficha";
import PrintListadoRecibosAcademicos from "./Academico/Recibos/Print/ListadoRecibos";
import PrintReciboInscripcion from "./Academico/Recibos/Print/ReciboInscripcion";
import PrintReciboMensualidad from "./Academico/Recibos/Print/ReciboMensualidad";
import PrintReciboCocurricular from "./Academico/Cocurriculares/Recibos/Print/ReciboCocurricular";
import PrintListadoRecibosCocurriculares from "./Academico/Cocurriculares/Recibos/Print/ListadoRecibosCocurricular";
import BalanceReport from "./Ingresos/print/BalanceReport";
import ReporteBalanceDetalle from "./Ingresos/print/ReporteBalanceDetalle";
import ReporteFacturasDetalles from "./Ingresos/print/ReporteFacturasDetalles";
import ReporteFacturasDetalles2 from "./Ingresos/print/ReporteFacturasDetalles2";
import ReporteListaCarga from "./Ingresos/print/ReporteListaCarga";
import ReporteListaCargaOC from "./Ingresos/print/ReporteListaCargaOC";
import DetalleComisiones from "./Nominas/Print/DetalleComisiones";
import PrintComisiones from "./Nominas/Print/Comisiones";
import PrintSingleNotaCredito from "./Consultas/NotasCredito/print/PrintSingleNotaCredito";
import PrintReporteNotasCredito from "./Consultas/NotasCredito/print/PrintReporteNotasCredito";
import ReporteNotasCreditoDetalles from "./Consultas/NotasCredito/print/ReporteNotasCreditoDetalles";
import PrintResumenCuentasPorCobrar from "./Consultas/CuentasPorCobrar/PrintResumenCuentasPorCobrar";
import PrintResumenCuentasPorPagar from "./Consultas/CuentasPorPagar/PrintResumenCuentasPorPagar";
import PrintResumenOrdenCompra from "./Ingresos/print/PrintResumenOrdenCompra";
import EntradasDiario from "./EntradasDiario/Print";
import Cheques from "./Cheques/Print";
import Contratos from "./Contratos/Print";
import PrintNominasEmpleado from "./Empleados/Nominas/Print/NominasEmpleado";
import SalarioNavidadDetalle from "./Empleados/Print/SalarioNavidadDetalle";
import ReportInventoryAdjustment from "./Productos/Print/ReportInventoryAdjustment";
import PrintAusencias from "./Ausencias/Print";
import VacacionesPrint from "./Ausencias/VacacionesPrint";
import PrintSingleAusencia from "./Ausencias/PrintSingleAusencia";
import PrintAusenciasEmpleados from "./Empleados/Ausencias/Print";
import ReportInventoryAdjustmentSingle from "./Productos/Print/ReportInventoryAdjustmentSingle";
import PrintSaludVisitas from "./Salud/Visitas/print";
import PrintCarta from "./Cartas/PrintCarta";
import PrintSolicitudPagoCXP from "./Consultas/CuentasPorPagar/PrintSolicitudPago";
import PrintSolicitudPagoCXC from "./Consultas/CuentasPorCobrar/PrintSolicitudPago";
import ComprobantesDetallesIncentivos from "./Nominas/Print/ComprobantesDetallesIncentivos";
import VacacionesPendientes from "./Empleados/Print/VacacionesPendientes";
import DespachoFacturasReporte from "./Ingresos/DespachoFacturas/Reporte";
import ListaCarga from "./Ingresos/DespachoFacturas/ListaCarga";
import ReporteOrdenCarga from "./Ingresos/DespachoFacturas/ReporteOrdenCarga";
import ReporteCuadreCaja from "./Ingresos/CuadreCaja/ReporteCuadreCaja";
import ReporteCuadreCajaVenta from "./Ingresos/CuadreCaja/ReporteCuadreCajaVenta";
import PrintInventarioMasivo from "./Productos/InventarioMasivo/Print"
import PrintCuadreDiarioVendedor from "./Ingresos/Facturacion/Components/PrintCuadreDiarioVendedor";
import GastosVehiculo from "./Vehiculos/Print/GastosVehiculo";
import PrintReporteNotasDebito from "./Ingresos/NotasDebito/print/PrintReporteNotasDebito";
import PrintSingleNotaDebito from "./Ingresos/NotasDebito/print/PrintSingleNotaDebito";
import ReporteNotasDebitoDetalles from "./Ingresos/NotasDebito/print/ReporteNotasDebitoDetalles";
class Imprimir extends Component {
    state = {
        isLoggedIn: auth.isLoggedIn(),
    };
    componentDidMount() {
        window.addEventListener("storage", this.syncLogout);
    }
    componentWillUnmount() {
        window.removeEventListener("storage", this.syncLogout);
        window.localStorage.removeItem("logout");
    }
    syncLogout = (event) => {
        if (event.key === "logout") {
            this.setState({ isLoggedIn: auth.isLoggedIn() });
        }
    };
    render() {
        if (!this.state.isLoggedIn) return <Login />;
        return (
            <div className='print-page'>
                <style>
                {`
                    @media print {
                        @page {
                            @bottom-center {
                                content: "Página " counter(page) " de " counter(pages);
                            }
                        }
                    }
                `}
                </style>
                <Routes>
                    <Route path='nomina/:id/comprobantes' element={<Comprobantes />} />
                    <Route path='nomina/:id/comprobantes-estandard' element={<ComprobantesEstandard />} />
                    <Route path='nomina/:id/comprobantes-normales' element={<ComprobantesNormales />} />
                    <Route path='nomina/:id/comprobantes-detalles' element={<ComprobantesDetalles />} />
                    <Route path='nomina/:id/comprobantes-detalles-incentivos' element={<ComprobantesDetallesIncentivos />} />
                    <Route path='nomina/:id/sobres' element={<Sobres />} />
                    <Route path='nomina/:id/sobres-detalles' element={<SobresDetalles />} />
                    <Route path='nomina/:id/resumen' element={<Resumen />} />
                    <Route path='nomina/:id/resumen-columnas' element={<ResumenColumnas />} />
                    <Route path='nomina/:id/resumen-columnas-categorizado' element={<ResumenColumnasCategorizado />} />
                    <Route path='nomina/:id/desglose-efectivo' element={<DesgloseEfectivo />} />
                    <Route path='nomina/:id/comisiones/:comision' element={<DetalleComisiones />} />
                    <Route path='nomina/:id/comisiones' element={<PrintComisiones />} />
                    <Route path='programacion/:id/despachados' element={<Despachados />} />
                    <Route path='programacion/:id/tarjetas' element={<Tarjetas />} />
                    <Route path='programacion/:id/ausentes' element={<Ausentes />} />
                    <Route path='programacion/:id/no-despachados' element={<NoDespachados />} />
                    <Route path='ticket/:numero' element={<DetalleTicket />} />
                    <Route path='reportes' element={<Reportes />} />
                    <Route path='solicitudes' element={<Solicitudes />} />
                    <Route path='solicitudes/:id' element={<Solicitud />} />
                    <Route path='reclamaciones/:id' element={<Reclamacion />} />
                    <Route path='reclamaciones' element={<Reclamaciones />} />
                    <Route path='servicios' element={<Servicios />} />
                    <Route path='vehiculos' element={<Vehiculos />} />
                    <Route path='vehiculos/detalle' element={<DetalleVehiculos />} />
                    <Route path='vehiculos/:id/gastos-internos' element={<GastosVehiculo />} />
                    <Route path='gastos-vehiculos' element={<GastosVehiculos />} />
                    <Route path='gastos-generales' element={<GastosGenerales />} />
                    <Route path='gastos-internos' element={<GastosInternos />} />
                    <Route path='rutas' element={<Rutas />} />
                    <Route path='gastos-internos/:id' element={<PrintComprobanteGasto />} />
                    <Route path='items' element={<Items />} />
                    <Route path='productos' element={<Productos />} />
                    <Route path='realizar-inventario' element={<RealizarInventario />} />
                    <Route path='productos-suplidor' element={<PrintReporteSuplidor />} />
                    <Route path='ventas' element={<HistorialVentas />} />
                    <Route path='catalogo' element={<CatalogueOfProducts />} />
                    <Route path='ajustes-inventario' element={<ReportInventoryAdjustment />} />
                    <Route path='ajustes-inventario/:ajusteId' element={<ReportInventoryAdjustmentSingle />} />
                    <Route path='reorden' element={<PrintProductosReorden />} />
                    <Route path='reorden-item' element={<PrintItemsReorden />} />
                    <Route path='facturas' element={<PrintFacturas />} />
                    <Route path='facturas-resumen' element={<PrintFacturasResumen />} />
                    <Route path='facturas-recurrentes' element={<PrintFacturasRecurrentes />} />
                    <Route path='facturas/:id' element={<PrintSingleFacturaNew />} />
                    <Route path='facturas/:id/doble' element={<PrintSingleFacturaNew />} />
                    <Route path='balance' element={<BalanceReport />} />
                    <Route path='balance-detalle' element={<ReporteBalanceDetalle />} />
                    <Route path='facturas-detalles' element={<ReporteFacturasDetalles />} />
                    <Route path='facturas-detalles-2' element={<ReporteFacturasDetalles2 />} />
                    <Route path='lista-carga' element={<ReporteListaCarga />} />
                    <Route path='lista-carga-oc' element={<ReporteListaCargaOC />} />
                    <Route path='cuentas-por-cobrar' element={<PrintCuentasPorCobrar />} />
                    <Route path='estados-cuenta' element={<PrintEstadosCuenta />} />
                    <Route path='cuentas-por-cobrar-resumen' element={<PrintResumenCuentasPorCobrar />} />
                    <Route path='cuentas-por-pagar' element={<PrintCuentasPorPagar />} />
                    <Route path='cuentas-por-pagar-resumen' element={<PrintResumenCuentasPorPagar />} />
                    <Route path='estados-cuenta-cxp' element={<PrintEstadosCuentaCXP />} />
                    <Route path='recibos-ingreso' element={<PrintRecibosIngresos />} />
                    <Route path='ordenes-compra' element={<PrintOrdenes />} />
                    <Route path='resumen-ordenes-compra' element={<PrintResumenOrdenCompra />} />
                    <Route path='ordenes-compra/:id' element={<PrintSingleOrden />} />
                    <Route path='ordenes-compra/reporte/cuadre-caja' element={<ReporteCuadreCajaOrden />} />
                    <Route path='ordenes-compra/reporte/cuadre-caja-venta' element={<ReporteCuadreCajaOrdenVenta />} />
                    <Route path='cotizaciones' element={<PrintCotizaciones />} />
                    <Route path='cotizaciones/:id' element={<PrintSingleCotizacion />} />
                    <Route path='recibos-ingreso/:id' element={<PrintSingleRecibo />} />
                    <Route path='compras' element={<PrintCompras />} />
                    <Route path='compras/:id' element={<PrintSingleCompra />} />
                    <Route path='notas-credito' element={<PrintReporteNotasCredito />} />
                    <Route path='notas-credito/:id' element={<PrintSingleNotaCredito />} />
                    <Route path='notas-credito-detalles' element={<ReporteNotasCreditoDetalles />} />
                    <Route path='notas-debito' element={<PrintReporteNotasDebito />} />
                    <Route path='notas-debito/:id' element={<PrintSingleNotaDebito />} />
                    <Route path='notas-debito-detalles' element={<ReporteNotasDebitoDetalles />} />
                    <Route path='compras-item' element={<HistorialComprasItems />} />
                    <Route path='compras-producto' element={<HistorialComprasProductos />} />
                    <Route path='empleados' element={<Empleados />} />
                    <Route path='lista-empleados' element={<ListaEmpleados />} />
                    <Route path='calculo-prestaciones' element={<CalculoPrestaciones />} />
                    <Route path='empleados/detalle' element={<DetalleEmpleados />} />
                    <Route path='empleados/cumpleanios' element={<Cumpleanios />} />
                    <Route path='empleados/vacaciones-pendientes' element={<VacacionesPendientes />} />
                    <Route path='empleados/salario-navidad' element={<SalarioNavidad />} />
                    <Route path='empleados/salario-navidad-detalle' element={<SalarioNavidadDetalle />} />
                    <Route path='empleados/:id/nominas' element={<PrintNominasEmpleado />} />
                    <Route path='empleados/salario-navidad-desglose' element={<SalarioNavidadDesglose />} />
                    <Route path='empleados/sobre-salario-navidad' element={<SobreSalarioNavidad />} />
                    <Route path='empleados/comprobante-salario-navidad' element={<ComprobanteSalarioNavidad />} />
                    <Route path='descuentos' element={<DescuentosProgramados />} />
                    <Route path='descuentos/:id' element={<DescuentoProgramado />} />
                    <Route path='descuentos/:id/recibo/:cuota' element={<ReciboDescuentoProgramado />} />
                    <Route path='incentivos' element={<Incentivos />} />
                    <Route path='incentivos/:id' element={<Incentivo />} />
                    <Route path='cuentas' element={<Cuentas />} />
                    <Route path='entradas-diario' element={<EntradasDiario />} />
                    <Route path='cheques' element={<Cheques />} />
                    <Route path='cuentas/:id/transacciones' element={<Transacciones />} />
                    <Route path='cuentas/:id/transacciones/:transaccion' element={<SingleTransaccion />} />
                    <Route path='gi-prestamos' element={<GIPrestamos />} />
                    <Route path='gi-grupos' element={<GIGrupos />} />
                    <Route path='contactos/:id/transacciones' element={<PrintTransaccionesHistory />} />
                    <Route path='contactos/:id/compras' element={<PrintTransaccionesCompras />} />
                    <Route path='cuadre-diario' element={<ReporteCuadre />} />
                    <Route path='cuadre-diario-vendedor' element={<PrintCuadreDiarioVendedor />} />
                    <Route path='cuadre-diario-resumido' element={<ReporteCuadreResumido />} />
                    <Route path='cuadre-caja-ventas' element={<ReporteCuadreCajaVentas />} />
                    <Route path='cuadre-compras' element={<ReporteCuadreCompra />} />
                    <Route path='detalle-compras' element={<ReporteDetalleCompra />} />
                    <Route path='academico/evaluaciones' element={<PrintEvaluaciones />} />
                    <Route path='academico/estudiantes' element={<PrintEstudiantes />} />
                    <Route path='academico/inscripciones' element={<PrintInscripciones />} />
                    <Route path='academico/inscripciones-cocurriculares' element={<PrintInscripcionesCocurriculares />} />
                    <Route path='academico/estudiantes/:id/clave' element={<PrintClave />} />
                    <Route path='academico/estudiantes/:id/ficha' element={<PrintFicha />} />
                    <Route path='academico/recibos/:id/cocurricular' element={<PrintReciboCocurricular />} />
                    <Route path='academico/recibos/cocurriculares' element={<PrintListadoRecibosCocurriculares />} />
                    <Route path='academico/recibos' element={<PrintListadoRecibosAcademicos />} />
                    <Route path='academico/recibos/:id/inscripcion' element={<PrintReciboInscripcion />} />
                    <Route path='academico/recibos/:id/mensualidad' element={<PrintReciboMensualidad />} />
                    <Route path='contratos' element={<Contratos />} />
                    <Route path='ausencias' element={<PrintAusencias />} />
                    <Route path='vacaciones' element={<VacacionesPrint />} />
                    <Route path='ausencias/:id' element={<PrintSingleAusencia />} />
                    <Route path='empleados/:id/ausencias' element={<PrintAusenciasEmpleados />} />

                    <Route path='salud/visitas' element={<PrintSaludVisitas />} />
                    <Route path='cartas/:id' element={<PrintCarta />} />

                    <Route path='cxp/solicitud-pago' element={<PrintSolicitudPagoCXP />} />

                    <Route path='cxc/solicitud-pago' element={<PrintSolicitudPagoCXC />} />
                    <Route path='ingresos/despacho-facturas/reporte' element={<DespachoFacturasReporte />} />
                    <Route path='ingresos/despacho-facturas/lista-carga' element={<ListaCarga />} />
                    <Route path='ingresos/despacho-facturas/orden-carga' element={<ReporteOrdenCarga />} />
                    <Route path='ingresos/cuadre-caja' element={<ReporteCuadreCaja />} />
                    <Route path='ingresos/cuadre-caja/resumen' element={<ReporteCuadreCajaVenta />} />
                    <Route path='inventario-masivo/:id' element={<PrintInventarioMasivo />} />
                </Routes>
            </div>
        );
    }
}

export default Imprimir;
